import HomeScreen from 'screens/home';
import ChartsScreen from 'screens/charts';
import ProfileScreen from 'screens/profile';
import ChatScreen from 'screens/chat';
import ConferenceScreen from 'screens/conference';
import LoginScreen from 'screens/login';
import CreateClassScreen from 'screens/createClass';
import AnalyticsScreen from 'screens/analytics';
import AnalyticInfoScreen from 'screens/analyticInfo';
import AttendeesScreen from 'screens/attendees';
import PrivacyPolicyScreen from 'screens/utilityScreens/privacyPolicy';
import TermsAndCondsScreen from 'screens/utilityScreens/termsAndConds';
import EditProfileScreen from 'screens/editProfile';
import AdminPanelGeneral from 'screens/adminPanel/general';
import AdminPanelTeachers from 'screens/adminPanel/teachers';
import AdminPanelGroups from 'screens/adminPanel/groups';
import AdminPanelGroupsInteraction from 'screens/adminPanel/groupInteraction';
import TranscriptionsScreen from 'screens/transcriptions';

export enum Flows {
  authFlow = 'AuthFlow',
  tabBarFlow = 'TabBarFlow',
  homeFlow = 'HomeFlow',
  analyticsFlow = 'AnalyticsFlow',
  adminPanelGeneralFlow = 'AdminPanelGeneralFlow',
  adminPanelGroupsFlow = 'AdminPanelGroupsFlow',
  profileFlow = 'ProfileFlow',
}

export enum ScreenName {
  login = 'Login',
  home = 'Home',
  details = 'Details',
  profile = 'Profile',
  adminPanelGeneral = 'AdminPanelGeneral',
  adminPanelTeachers = 'AdminPanelTeachers',
  adminPanelGroups = 'AdminPanelGroups',
  adminPanelGroupsInteraction = 'AdminPanel_GroupsInteraction',
  createClass = 'CreateClass',
  chat = 'Chat',
  charts = 'Charts',
  conference = 'Conference',
  analytics = 'Analytics',
  analyticInfo = 'AnalyticInfo',
  attendees = 'Attendees',
  privacy = 'Privacy',
  terms = 'Terms',
  editProfile = 'Edit Profile',
  transcriptions = 'Transcriptions',
}

export const Screens = {
  LoginScreen: {screen: LoginScreen, name: ScreenName.login, link: '/login'},
  HomeScreen: {screen: HomeScreen, name: ScreenName.home, link: '/'},
  ChartsScreen: {
    screen: ChartsScreen,
    name: ScreenName.charts,
    link: '/charts',
  },
  ProfileScreen: {
    screen: ProfileScreen,
    name: ScreenName.profile,
    link: '/profile',
  },
  PrivacyPolicyScreen: {
    screen: PrivacyPolicyScreen,
    name: ScreenName.privacy,
    link: '/privacy',
  },
  TermsAndCondsScreen: {
    screen: TermsAndCondsScreen,
    name: ScreenName.terms,
    link: '/terms',
  },
  EditProfileScreen: {
    screen: EditProfileScreen,
    name: ScreenName.editProfile,
    link: '/edit-profile',
  },
  AdminPanelGeneralScreen: {
    screen: AdminPanelGeneral,
    name: ScreenName.adminPanelGeneral,
    link: '/admin-panel',
  },
  AdminPanelTeachersScreen: {
    screen: AdminPanelTeachers,
    name: ScreenName.adminPanelTeachers,
  },
  AdminPanelGroupsScreen: {
    screen: AdminPanelGroups,
    name: ScreenName.adminPanelGroups,
  },
  AdminPanelGroupsInteractionScreen: {
    screen: AdminPanelGroupsInteraction,
    name: ScreenName.adminPanelGroupsInteraction,
  },

  CreateClassScreen: {
    screen: CreateClassScreen,
    name: ScreenName.createClass,
    link: '/create-class',
  },

  ChatScreen: {screen: ChatScreen, name: ScreenName.chat, link: '/chat'},
  ConferenceScreen: {
    screen: ConferenceScreen,
    name: ScreenName.conference,
    link: '/conference',
  },
  AnalyticsScreen: {
    screen: AnalyticsScreen,
    name: ScreenName.analytics,
    link: '/Analytics',
  },
  AnalyticInfoScreen: {
    screen: AnalyticInfoScreen,
    name: ScreenName.analyticInfo,
    link: '/info',
  },
  AttendeesScreen: {
    screen: AttendeesScreen,
    name: ScreenName.attendees,
    link: '/attendees',
  },
  TranscriptionsScreen: {
    screen: TranscriptionsScreen,
    name: ScreenName.transcriptions,
    link: '/transcriptions',
  },
};
